/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */

import { nanoid } from 'nanoid';
import { Provider, ProviderValueFactory } from '../provider/types';
import { Container, ExtendContainer } from './types';
import { createModule } from '../module';

/* @__NO_SIDE_EFFECTS__ */
export function createContainer<Deps>(
  containerName = 'Unnamed'
): Container<Deps> {
  /* @__NO_SIDE_EFFECTS__ */
  const createProvider = (
    factory: ProviderValueFactory,
    innerDeps = {} as any
  ): Provider => {
    const provider = {
      __value: undefined as any,
      __innerDeps: undefined as any,
      id: `${factory.name}-${nanoid()}`,
      containerName,
      innderDeps: innerDeps,
      factory,
      init: (deps: Deps) => createModule(provider).init(deps),
    };
    return provider;
  };

  const extend: ExtendContainer<Deps> = (name) => {
    return createContainer(name);
  };

  return {
    __deps: null as Deps,
    extend,
    containerName,
    provider: createProvider as any,
  };
}
